import { FC } from 'react';

import { useTranslations } from '../hooks/useTranslations';
import { translationKeys } from '../translations/translationKeys';

type Props = {
  onConfirm: () => void;
  onDismiss: () => void;
};

const CfdAddOnModal: FC<Props> = ({ onConfirm, onDismiss }) => {
  const { translate } = useTranslations();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl w-full max-w-sm mx-4 px-6 pt-8 pb-8 flex flex-col">
        <h2 className="text-2xl font-bold text-content-primary mb-3">
          {translate(translationKeys.LOOKING_FOR_CFDS_OPTIONS)}
        </h2>

        <p className="text-sm text-content-secondary mb-8">{translate(translationKeys.CAN_ADD_CFDS_OPTIONS)}</p>

        <button
          type="button"
          onClick={onConfirm}
          className="w-full py-4 px-4 bg-[#3B5BDB] hover:bg-[#2F4BC4] active:bg-[#2439A8] cursor-pointer transition-colors !text-white rounded-full font-medium mb-4 text-base"
        >
          {translate(translationKeys.YES_FIND_OUT_MORE)}
        </button>

        <button
          type="button"
          onClick={onDismiss}
          className="w-full py-4 px-4 bg-white border border-[#3B5BDB] hover:bg-azure-10 active:bg-azure-20 cursor-pointer transition-colors text-content-primary rounded-full font-medium text-base"
        >
          {translate(translationKeys.NOT_NOW)}
        </button>
      </div>
    </div>
  );
};

export default CfdAddOnModal;
